/**
 * Tek sozluk — tum arayuz metinleri burada, komponent icinde sabit metin YOK
 * (docs/faz5-arayuz-spec.md §1). Anahtarlar nokta-ad-alani (`nav.ozet`) ile
 * gruplanir; `t()` (bkz. ./index.ts) eksik anahtar icin anahtar adini dondurur.
 */
export const tr = {
  "app.title": "AsakAI",
  "app.tagline": "Yönetici KPI paneli",
  "app.footer": "İmga AI ile güçlendirilmiş e-ticaret gidişat paneli",
  "auth.login.tagline": "E-ticaret yönetici paneline giriş",
  "ozet.period.label": "Gidişat dönemi",
  "ozet.sec.gidisat": "E-Ticaret Gidişatı",
  "ozet.sec.gidisat_not": "satıştan pazarlamaya, yorumdan kargoya tek bakışta · son {{n}} gün, önceki {{n}} güne göre",
  "ozet.sec.teslimat": "Uçtan Uca Teslimat Süresi",
  "ozet.sec.teslimat_not": "sipariş anından müşteriye teslime, haftalık ortalama",
  "ozet.sec.saglik": "Operasyon Sağlık Skoru",
  "ozet.sec.op": "Operasyonel Durum",
  "ozet.sec.op_not": "acil dikkat gerekenler",
  "ozet.sec.kargo": "Kargo Şirketi Dağılımı",
  "ozet.sec.yorum": "Müşteri Yorumları",
  "ozet.sec.yorum_not": "gerçek müşteri puanları",
  "ozet.sec.saatlik": "Saatlik Satış",
  "ozet.sec.saatlik_not": "bugün ve dün, saat bazında ciro",
  "ozet.sec.encok": "Bu Haftanın En Çok Satan Ürünleri",
  "ozet.veri_notlari": "Veri notları ({{n}})",
  "ozet.pazarlama.bagli_degil": "Reklam hesabı bağlı değil; Meta veya Google Ads bağlandığında harcama, ROAS ve MER burada görünür.",
  "ozet.pazarlama.hata": "Reklam bağlantısının süresi dolmuş ya da veri çekilemiyor.",
  "ozet.pazarlama.baglanti_link": "Bağlantıları düzenle",
  "ozet.ai.goster": "göster",
  "ozet.ai.gizle": "gizle",
  "ozet.ai.devamini_goster": "Devamını göster",
  "ozet.ai.daha_az": "Daha az",
  "ozet.ai.daha": "daha",
  "ozet.ai.yeniden_uret_ipucu": "AI notunu yeniden üret (yaklaşık 15-30 sn, kredi harcar)",
  "kpi.site_metrikleri.kirilim": "Kırılım",
  "kpi.site_metrikleri.bagli_olmayan": "Bağlı olmayan metrikler ({{n}})",
  "kpi.site_metrikleri.kategori_bos": "Bu kategoride bağlı metrik yok.",
  "kpi.sec.reklam": "Reklam Performansı",
  "kpi.sec.reklam_not": "Meta + Google Ads birleşik",
  "kpi.reklam.bagli_degil": "Reklam hesabı bağlı değil. Meta Ads bağlandığında harcama, ROAS, huni ve harcama etkisi burada görünür.",
  "kpi.reklam.hata": "Reklam bağlantısı hata veriyor: {{detay}}",
  "kpi.reklam.meta_veri_alinamadi": "Meta reklam verisi alınamadı. Ayarlar → Bağlantılar'dan hesap ve erişim anahtarını kontrol edin.",
  "kpi.title_sub": "Trafik, müşteri davranışı, satış ve operasyon metrikleri",
  "kpi.havuz.huni_veri_yok": "Seçili kaynak ve aralıkta huni verisi yok.",
  "ozet.teslimat.grafik_ipucu": "Bir haftaya tıklayınca o haftanın siparişleri açılır",
  "sghv.bir_yildan_uzun": "> 1 yıl",
  "sghv.devir_yavas_not": "stok bir yılda bile dönmüyor",
  "sghv.devir_not": "mevcut stoğun tükenme süresi",
  "sghv.stok_link": "Stok sekmesinde",
  "health.breakdown.ipucu": "Skorun dökümü için tıkla",
  "health.breakdown.sub": "Her KPI ağırlığı kadar puan kaybettirir",
  "health.breakdown.agirlik": "ağırlık {{n}}",

  // -- ust bar / gezinme -----------------------------------------------------
  "nav.ozet": "Özet",
  "nav.kpi": "KPI",
  "nav.stok": "Stok",
  "nav.yorumlar": "Yorumlar",
  "nav.denetim": "Denetim",
  "nav.ayarlar": "Ayarlar",
  "nav.kurulum": "Kurulum",
  "nav.kullanicilar": "Kullanıcılar",
  "nav.admin": "Yönetici",
  "nav.more": "Daha",
  "nav.skip": "İçeriğe geç",
  "nav.logout": "Çıkış yap",
  "nav.switch_tenant": "Mağaza değiştir",

  // -- oturum -----------------------------------------------------------------
  "auth.login.title": "Giriş yap",
  "auth.login.email": "E-posta",
  "auth.login.password": "Şifre",
  "auth.login.submit": "Giriş yap",
  "auth.login.submitting": "Giriş yapılıyor…",
  "auth.login.register_link": "Hesabın yok mu? Kayıt ol",
  "auth.login.forgot_link": "Şifremi unuttum",
  "auth.login.error": "E-posta ya da şifre hatalı",
  "auth.register.title": "Kayıt ol",
  "auth.register.tenant_slug": "Mağaza kodu",
  "auth.register.first_name": "Ad",
  "auth.register.last_name": "Soyad",
  "auth.register.submit": "Kayıt ol",
  "auth.register.success": "Hesabınız/üyeliğiniz onay bekliyor.",
  "auth.password.title": "Şifre değiştir",
  "auth.password.current": "Mevcut şifre",
  "auth.password.new": "Yeni şifre",
  "auth.password.submit": "Şifreyi güncelle",
  "auth.password.success": "Şifreniz güncellendi.",
  "auth.tenant_select.title": "Mağaza seç",
  "auth.tenant_select.empty": "Hiçbir mağazaya üyeliğiniz yok.",
  "auth.tenant_select.super_hint": "Süper yönetici olarak tüm mağazalara erişebilirsiniz.",
  "auth.tenant_select.go_admin": "Yönetim ekranına git (mağazaya geç)",
  "tenant_sec.status.active": "Aktif",
  "tenant_sec.status.pending": "Onay bekliyor",
  "tenant_sec.status.rejected": "Reddedildi",

  // -- ortak durum/platform etiketleri (bkz. lib/labels.ts) — Kullanicilar/
  // Admin tenant tablosu/TenantSec'te HAM enum degerleri yerine kullanilir
  // (arayuz-denetim-duzeltmeleri gorev madde 3). active/pending/rejected icin
  // yukaridaki tenant_sec.status.*, rol icin asagidaki kullanicilar.role.*
  // YENIDEN KULLANILIR — burada yalniz EKSIK olanlar eklenir.
  "status.disabled": "Devre dışı",
  "status.setup": "Kurulum",
  "status.suspended": "Askıda",
  "status.archived": "Arşiv",
  "platform.ticimax": "Ticimax",
  "platform.ikas": "ikas",
  "platform.shopify": "Shopify",
  "kurulum.platform.shopify": "Shopify",
  "platform.ideasoft": "IdeaSoft",

  // -- ozet/gidisat -------------------------------------------------------------
  "ozet.title": "Gidişat özeti",
  "ozet.period.7": "7 gün",
  "ozet.period.30": "30 gün",
  "ozet.period.90": "90 gün",
  "kpi.period.label": "Kuyruk dönemi",
  "kpi.havuz.kaynak_filtre": "Kaynak filtresi",
  "kpi.havuz.kaynak_tumu": "Tümü",
  "kpi.havuz.kaynak_google": "Google",
  "kpi.site_metrikleri.baslik": "Site Metrikleri",
  "kpi.site_metrikleri.alt": "GA4 + Ticimax",
  "kpi.site_metrikleri.kaynak": "Kaynak: {{kaynak}}",
  "kpi.site_metrikleri.kirilim_ad": "Kırılım",
  "kpi.site_metrikleri.alan.sessions": "Oturum",
  "kpi.site_metrikleri.alan.users": "Kullanıcı",
  "kpi.site_metrikleri.alan.count": "Adet",
  "kpi.site_metrikleri.alan.sold": "Satılan",
  "kpi.site_metrikleri.alan.revenue": "Ciro",
  "kpi.huni.alt": "GA4 kapalı huni · ziyaretten satın almaya, kullanıcı bazında",
  "kpi.funnel.gosterim": "Gösterim",
  "kpi.funnel.donusum": "Dönüşüm",
  "kpi.funnel.caption": "Reklam dönüşüm hunisi (gösterim → tıklama → dönüşüm)",
  "kpi.period.today": "Bugün",
  "kpi.period.7": "Son 7 gün",
  "kpi.period.30": "Son 30 gün",
  "kpi.period.90": "Son 90 gün",
  "kpi.period.all": "Tüm zamanlar",
  "delta.mode.title": "Fark gösterim modu",
  "delta.mode.pct": "% Fark",
  "delta.mode.value": "Değer Farkı",
  "kpi.aralik.baslik": "Reklam veri aralığı",
  "kpi.aralik.son7": "Son 7 gün",
  "kpi.aralik.son30": "Son 30 gün",
  "kpi.aralik.son90": "Son 90 gün",
  "kpi.aralik.ozel": "Özel aralık",
  "kpi.aralik.baslangic": "Başlangıç",
  "kpi.aralik.bitis": "Bitiş",
  "kpi.aralik.uygula": "Uygula",
  "kpi.havuz.baslik": "Reklam Performansı — Ortak Havuz",
  "kpi.havuz.alt": "Meta + Google Ads birleşik (aralık aşağıdan seçilir)",
  "kpi.havuz.toplam_harcama": "Toplam Harcama",
  "kpi.havuz.toplam_satis": "Reklam Kaynaklı Satış",
  "kpi.havuz.roas": "ROAS",
  "kpi.havuz.tiklama": "Toplam Tıklama",
  "kpi.havuz.kaynak_dagilimi": "Harcama dağılımı — kaynağa göre",
  "kpi.havuz.kaynak_dagilimi_veri_yok": "Harcama dağılımı — veri yok",
  "kpi.havuz.gunluk_trend": "Günlük harcama trendi",
  "kpi.havuz.meta": "Meta",
  "kpi.havuz.google": "Google Ads",
  "kpi.harcama_etkisi.baslik": "Harcama Etkisi",
  "kpi.harcama_etkisi.alt": "maliyet değişimi KPI'ları nasıl etkiledi?",
  "kpi.harcama_etkisi.harcama": "Harcama",
  "kpi.harcama_etkisi.satis_degeri": "Satış Değeri",
  "kpi.harcama_etkisi.satin_alma": "Satın Alma",
  "kpi.harcama_etkisi.roas": "ROAS",
  "kpi.harcama_etkisi.onceki_donem": "önceki dönem: {{deger}}",
  "kpi.harcama_etkisi.veri_yok": "Bu dönemde reklam verisi yok (son veri: {{tarih}})",
  "kpi.harcama_etkisi.no_prev": "Önceki dönemde harcama verisi yok — kıyas bir sonraki dönemde netleşecek.",
  "kpi.harcama_etkisi.artti_pozitif": "Harcama {{spend}} arttı ve verimlilik korundu/yükseldi: harcanan her 1₺'nin getirisi {{roas}}. Satış değeri {{pval}}, satın alma {{pur}}. Artan maliyetin KPI'lara etkisi POZİTİF.",
  "kpi.harcama_etkisi.artti_karisik": "Harcama {{spend}} arttı; satışlar da arttı (değer {{pval}}) ama verimlilik düştü (ROAS {{roas}}). Etki KARIŞIK — büyüme pahalıya geliyor.",
  "kpi.harcama_etkisi.artti_negatif": "Harcama {{spend}} arttı ama satış değeri {{pval}}. Artan maliyet karşılığını vermedi — etki NEGATİF, kampanyalar gözden geçirilmeli.",
  "kpi.harcama_etkisi.azaldi_pozitif": "Harcama {{spend}} azaldı ama satış değeri korundu ({{pval}}). Verimlilik yükseldi (ROAS {{roas}}) — daha azla aynı sonuç, etki POZİTİF.",
  "kpi.harcama_etkisi.azaldi_karisik": "Harcama {{spend}} azaldı; satışlar da azaldı ({{pval}}) ama verimlilik düşmedi (ROAS {{roas}}). Küçülme kontrollü.",
  "kpi.harcama_etkisi.azaldi_negatif": "Harcama {{spend}} azaldı ve hem satışlar ({{pval}}) hem verimlilik (ROAS {{roas}}) geriledi.",
  "sghv.baslik": "Stok Devir Hızı (SGHV)",
  "sghv.not": "kart bazında, son 30 gün · kritik stok detayı",
  "sghv.genel": "SGHV Genel",
  "sghv.genel_alt": "{{adet}} adet / {{kart}} kart",
  "sghv.ortalama_gun": "Ortalama devir süresi",
  "sghv.gun": "gün",
  "sghv.kart": "kart",
  "sghv.yavas": "🐢 Yavaş hareket",
  "sghv.yavas_alt": "< {{esik}} devir hızı",
  "sghv.hizli": "🚀 Hızlı hareket",
  "sghv.hizli_alt": "> {{esik}} devir hızı",
  "sghv.veri_yok": "veri yok",
  "sghv.veri_yetersiz": "veri yetersiz",
  "stok.tab.tumu": "Tüm ürünler",
  "stok.col.grup": "Grup",
  "stok.grup.tukendi": "Tükendi",
  "stok.grup.kritik": "Kritik",
  "stok.grup.yakin": "Yaklaşan",
  "stok.grup.cok_satan": "Çok satan",
  "stok.grup.az_satan": "Az satan",
  "stok.grup.normal": "Normal",
  "stok.col.kategori": "Kategori",
  "stok.col.fiyat": "Fiyat",
  "stok.col.toplam_stok": "Toplam stok",
  "stok.col.varyantlar": "Beden / Stok",
  "stok.seviye.aciklama": "Bu görünüm stok seviyesi bazlıdır (adet). Satış hızına göre aciliyet için Kritik/Yaklaşan sekmelerine bak.",
  "stok.seviye.tamamen_tukenen": "Tamamen tükenmiş (satıştan düşmeli)",
  "stok.seviye.bedeni_eksik": "Bedeni eksik (satışta — bazı bedenler tükendi)",
  "stok.seviye.azalan": "Stoğu azalan aktif kart (1-9)",
  "stok.seviye.bolum_bos": "Bu bölümde kart yok.",
  "denetim.yazdir": "PDF / Yazdır",
  // -- gorev A: katalog denetimi kural paneli (eski legacy/denetim.html) ----
  "denetim.kural.baslik": "Denetim Kuralı",
  "denetim.kural.kelime": "Aranan malzeme/ifade",
  "denetim.kural.yuzde": "Yüzde",
  "denetim.kural.ozellik_adi": "Filtrelenebilir özellik alanı",
  "denetim.kural.rozet_dosyasi": "Rozet görseli (dosya adı)",
  "denetim.kural.kategoriler": "Kategoriler",
  "denetim.kural.kategoriler_yardim": "(boş = tümü, Ctrl ile çoklu seçim)",
  "denetim.kural.urun_adi_kontrol": "Ürün adındaki ifadeyi de say",
  "denetim.kural.gri_alan": "Gri alanı göster (yüzdesiz eşleşme)",
  "denetim.kural.satisa_kapali_dahil": "Satışa kapalı ürünleri de denetle",
  "denetim.kural.ozet_satiri": "Kurallar: kelime={{kelime}}, yüzde={{yuzde}}, özellik={{ozellik}}, rozet={{rozet}}",
  // -- gorev B: denetim degisken dagilimi tablosu ----------------------------
  "denetim.dagilim.baslik": "📊 {{ozellik}} değer dağılımı",
  "denetim.dagilim.deger": "Değer",
  "denetim.dagilim.urun": "Ürün",
  // -- gorev C: mevcut uye icin sifre sifirlama (eski legacy/admin/users.html) --
  "kullanicilar.password.action": "Şifre sıfırla",
  "kullanicilar.password.title": "Şifre Değiştir",
  "kullanicilar.password.target": "Kullanıcı: {{email}}",
  "kullanicilar.password.new_label": "Yeni şifre",
  "kullanicilar.password.placeholder": "Min 8 karakter",
  "kullanicilar.password.generate": "🎲 Oluştur",
  "kullanicilar.password.save": "Kaydet",
  "kullanicilar.password.saving": "Kaydediliyor…",
  "kullanicilar.password.updated_title": "✓ Şifre güncellendi",
  "kullanicilar.password.updated_hint": "Kullanıcıya iletilecek şifre — bu pencereyi kapatınca tekrar gösterilmez:",
  "kullanicilar.password.copy": "Kopyala",
  "kullanicilar.password.copied": "Kopyalandı.",
  "kullanicilar.password.too_short": "Şifre en az 8 karakter olmalı.",
  "yorumlar.filtre.urun": "Ürün",
  "yorumlar.filtre.tum_urunler": "Tüm ürünler",
  "yorumlar.filtre.arama": "Yorumlarda ara",

  // -- gorev A: yorum karti ek alanlari + "Urunu onerenler" KPI'si -----------
  "yorumlar.rozet.oneriyor": "👍 Öneriyor",
  "yorumlar.rozet.faydali": "{{n}} kişi faydalı buldu",
  "yorumlar.rozet.onay_bekliyor": "Onay bekliyor",
  "yorumlar.magaza_cevabi": "Mağaza cevabı",
  "yorumlar.ozet.oneren_yuzde": "Ürünü önerenler",

  // -- gorev C: haftalik teslimat grafigi interaktifligi ----------------------
  "ozet.teslimat.genel_ortalama": "Genel ortalama",
  "ozet.teslimat.son_hafta": "Son hafta",
  "ozet.teslimat.teslim_olculdu": "{{n}} teslim ölçüldü",
  "ozet.teslimat.siparis_adet": "{{n}} sipariş",
  "ozet.teslimat.veri_kapsami": "Veri kapsamı",
  "ozet.teslimat.veri_kapsami_sub": "geçmiş dolduruluyor",
  "ozet.teslimat.hafta_aria": "Haftalık teslimat grafiği — bir haftaya tıklayarak sipariş listesini aç",
  "ozet.teslimat.hafta_baslik": "{{n}}. Hafta",
  "ozet.teslimat.hafta_listesi": "Haftalar (klavye ile seçim)",
  "ozet.teslimat.ortalama_seri": "Ortalama teslimat",
  "ozet.teslimat.modal_baslik": "{{n}}. Hafta Teslimatları ({{adet}})",
  "ozet.teslimat.ortalama_not": "Ortalama: {{deger}} · süre = sipariş anı → müşteriye teslim anı.",
  "ozet.teslimat.kolon.siparis": "Sipariş",
  "ozet.teslimat.kolon.musteri": "Müşteri",
  "ozet.teslimat.kolon.tutar": "Tutar",
  "ozet.teslimat.kolon.siparis_ani": "Sipariş Anı",
  "ozet.teslimat.kolon.teslim_ani": "Teslim Anı",
  "ozet.teslimat.kolon.gecen_sure": "Geçen Süre",
  "ozet.teslimat.kolon.kargo": "Kargo",

  // -- gorev D: kpi detay modali "Islenmis / Ham veri" sekmesi ----------------
  "ozet.detay.tab_aria": "Detay görünümü",
  "ozet.detay.tab_islenmis": "İşlenmiş",
  "ozet.detay.tab_ham_veri": "Ham Veri",
  "ozet.detay.ham_veri_yok": "Ham veri yok.",
  "ozet.detay.ham_veri_kesildi": "İlk {{n}} satır gösteriliyor (toplam {{toplam}}).",
  "health.unknown": "—",
  "health.label": "Sağlık skoru",

  // -- kart durumlari -----------------------------------------------------------
  "card.state.live": "Canlı",
  "card.state.not_connected": "Bağlı değil",
  "card.state.not_supported": "Bu platformda yok",
  "card.reason.henuz_senkron_yok": "Henüz senkronize edilmedi",
  "card.reason.yeniden_yetkilendir": "Yeniden yetkilendirme gerekli",
  "card.reason.baglanti_eksik": "Bağlantı eksik",
  "card.setup_link": "Kurulumu tamamla",
  "card.analyze": "AI ile analiz et",

  // -- tazelik / yenile -----------------------------------------------------------
  "freshness.updated_ago": "Son güncelleme: {{time}}",
  "freshness.never": "Henüz güncellenmedi",
  "freshness.refresh": "Yenile",
  "freshness.refreshing": "Yenileniyor…",
  "freshness.cooldown": "Az önce yenilendi, biraz sonra tekrar deneyin",

  // -- bos durum -----------------------------------------------------------------
  "empty.not_connected.title": "Bağlı değil",
  "empty.not_connected.body": "Bu veri kaynağı henüz bağlanmadı.",
  "empty.not_supported.title": "Desteklenmiyor",
  "empty.not_supported.body": "Bu veri mevcut mağaza bağlantısından alınamıyor.",
  "empty.no_data.title": "Veri yok",
  "empty.no_data.body": "Gösterilecek bir şey bulunamadı.",
  "empty.error.title": "Hata",
  "empty.error.body": "Bir hata oluştu.",

  // -- alarm -----------------------------------------------------------------------
  "alarm.sound": "Ses",
  "alarm.flash": "Ekran flaşı",
  "alarm.title": "Sekme başlığı",

  // -- sirlanabilir tablo -----------------------------------------------------------
  "table.scroll_hint": "Tabloyu görmek için yana kaydırın →",
  "table.empty": "Kayıt yok",
  "table.gosterilen": "{{n}} / {{toplam}} satır gösteriliyor",
  "table.daha_fazla": "{{n}} satır daha göster",
  "order_status.confirmed": "Onaylandı",
  "order_status.preparing": "Hazırlanıyor",
  "order_status.shipped": "Kargoda",
  "order_status.delivered": "Teslim edildi",
  "order_status.cancelled": "İptal",
  "order_status.returned": "İade",
  "order_status.refunded": "Para iadesi",
  "order_status.pending_payment": "Ödeme bekliyor",
  "order_status.payment_attempt": "Ödeme girişimi",
  "order_status.unknown": "Bilinmiyor",

  // -- genel -----------------------------------------------------------------------
  "common.loading": "Yükleniyor…",
  "common.error": "Bir hata oluştu",
  "common.retry": "Tekrar dene",
  "common.save": "Kaydet",
  "common.cancel": "Vazgeç",
  "common.close": "Kapat",
  "common.open_full_panel": "Paneli tam ekran aç",

  // -- yer tutucu sayfalar -----------------------------------------------------------
  "placeholder.kpi.title": "KPI",
  "placeholder.kpi.body": "Detaylı KPI analizleri bu sayfada (P5-F2) yayına girecek.",
  "placeholder.stok.title": "Stok",
  "placeholder.stok.body": "Stok analizi sekmeleri bu sayfada (P5-F3) yayına girecek.",
  "placeholder.yorumlar.title": "Yorumlar",
  "placeholder.yorumlar.body": "Müşteri yorumları analizi bu sayfada (P5-F3) yayına girecek.",
  "placeholder.denetim.title": "Katalog denetimi",
  "placeholder.denetim.body": "Katalog denetimi bu sayfada (P5-F3) yayına girecek.",
  "placeholder.ayarlar.title": "Ayarlar",
  "placeholder.ayarlar.body": "Mağaza ayarları bu sayfada (P5-F4) yayına girecek.",
  "placeholder.kurulum.title": "Kurulum sihirbazı",
  "placeholder.kurulum.body": "Platform kurulum sihirbazı bu sayfada (P5-F4) yayına girecek.",
  "placeholder.kullanicilar.title": "Kullanıcılar",
  "placeholder.kullanicilar.body": "Üye/rol yönetimi bu sayfada (P5-F4) yayına girecek.",
  "placeholder.admin.title": "Süper yönetici",
  "placeholder.admin.body": "Tenant listesi ve sistem sağlığı bu sayfada (P5-F4) yayına girecek.",

  // -- /embed/ikas (P5-F5) -------------------------------------------------------
  "embed.title": "AsakAI — özet",
  // -- gorev A: kayit sifre tekrar (esitlik) --------------------------------------
  "auth.register.password_confirm": "Şifre (tekrar)",
  "auth.register.password_hint": "En az 8 karakter, 1 sayı, 1 büyük + 1 küçük harf",
  "auth.register.password_mismatch": "Şifreler eşleşmiyor.",
  // -- gorev B: bekleyen onay rozeti (esitlik) ------------------------------------
  "nav.pending_badge": "Bekleyen onay: {{count}}",
  // -- gorev C: /admin Imga AI karti (esitlik) ------------------------------------
  "admin.imga.title": "İmga AI",
  "admin.imga.description": "AsakAI tüm AI çağrılarını İmga AI üzerinden yapar. Anahtar boşsa sistem MOCK modda çalışır.",
  "admin.imga.status_connected": "Bağlı",
  "admin.imga.status_not_connected": "Bağlı değil — MOCK modda çalışıyor",
  "admin.imga.status_mock_note": "Mock modda — gerçek bağlantı doğrulanmadı",
  "admin.imga.updated_at": "Son güncelleme: {{time}}",
  "admin.imga.api_url": "API URL",
  "admin.imga.tenant_id": "Tenant ID",
  "admin.imga.api_key_label": "API Anahtarı",
  "admin.imga.api_key_placeholder": "imga_live_...",
  "admin.imga.save": "Kaydet",
  "admin.imga.saving": "Kaydediliyor…",
  "admin.imga.delete": "Sil",
  "admin.imga.deleting": "Siliniyor…",
  "admin.imga.test": "Test Et",
  "admin.imga.testing": "Test ediliyor…",
  "admin.imga.save_success": "Kaydedildi.",
  "admin.imga.delete_success": "İmga bağlantısı silindi.",
  "admin.imga.delete_confirm": "İmga bağlantısı silinsin mi? AsakAI MOCK moduna geçer.",
  "admin.imga.test_success": "Bağlantı başarılı.",
  "admin.imga.error": "İşlem başarısız.",
  "admin.imga.key_required": "Anahtar boş olamaz.",
  // -- gorev D: tazelik gostergesi canli/bayat (esitlik) --------------------------
  "freshness.live": "Canlı",
  "freshness.stale_badge": "Bayat",
  "embed.loading": "Oturum açılıyor…",
  "embed.unauthorized": "Gömülü oturum açılamadı.",
  "embed.unauthorized_hint": "Panele tam ekranda giriş yapıp tekrar deneyin.",
  "embed.error": "Özet yüklenemedi.",
  "embed.login_full": "Tam ekranda giriş yap",

  // -- stok (P5-F3) -----------------------------------------------------------
  "stok.tab.kritik": "Kritik",
  "stok.tab.yakin": "Yakın",
  "stok.tab.cok_satan": "Çok satan",
  "stok.tab.az_satan": "Az satan",
  "stok.tab.beden": "Beden",
  "stok.tab.seviye": "Seviye",
  "stok.col.urun": "Ürün",
  "stok.col.beden": "Beden",
  "stok.col.satilan": "Satılan",
  "stok.col.stok": "Stok",
  "stok.col.gunluk_hiz": "Günlük hız",
  "stok.col.kalan_gun": "Kalan gün",
  "stok.col.son_siparis": "Son sipariş",
  "stok.col.toplam_satilan": "Toplam satılan",
  "stok.col.varyant_sayisi": "Varyant",
  "stok.col.stok_sifir": "Stok=0",
  "stok.gun_kisaltma": "gün",
  "stok.ozet.kritik": "Kritik",
  "stok.ozet.kritik_sub": "satın alma kararı gerekli",
  "stok.ozet.yakin": "Yakın",
  "stok.ozet.yakin_sub": "takipte tut",
  "stok.ozet.az_satan": "Az satan",
  "stok.ozet.az_satan_sub": "kampanya / delist adayı",
  "stok.ozet.cok_satan": "Çok satan",
  "stok.ozet.toplam_satis": "{{adet}} toplam satış",
  "stok.kapsam.satisa_kapali": "{{adet}} satışa kapalı kart analiz dışı bırakıldı",
  "stok.kapsam.satisa_kapali_stok": "bu kartlarda {{adet}} adet stok duruyor",
  "stok.kapsam.cift_birlesti": "{{adet}} çift açılmış kart grubu birleştirildi (stoklar toplandı)",
  "stok.kapsam.cift_tespit": "{{adet}} çift açılmış kart grubu tespit edildi",
  "stok.ara_placeholder": "Ürün adı veya SKU ara…",

  // -- yorumlar (P5-F3) ---------------------------------------------------------
  "yorumlar.puansiz": "puansız",
  "yorumlar.satin_aldi": "✓ Satın aldı",
  "yorumlar.metin_yok": "Yorum metni yok",
  "yorumlar.anonim": "Anonim",
  "yorumlar.filtre.hepsi": "Tümü",
  "yorumlar.filtre.aria": "Yıldız filtresi",
  "yorumlar.ai.buton": "AI ile analiz et",
  "yorumlar.ai.baslik": "AI yorum analizi",
  "yorumlar.ai.yukleniyor": "Analiz ediliyor…",
  "yorumlar.ai.default_prompt": "Bu müşteri yorumlarını özetle: güçlü/zayıf yönler, tekrar eden şikayetler ve önerilen aksiyonlar.",
  "yorumlar.ozet.toplam": "Toplam yorum",
  "yorumlar.ozet.ort_puan": "Ortalama puan",
  "yorumlar.ozet.urun_sayisi": "Ürün sayısı",
  "yorumlar.ozet.dusuk_puan": "Düşük puan",
  "yorumlar.ozet.onay_bekleyen": "Onay bekleyen",
  "yorumlar.govde.devamini_goster": "Devamını göster",
  "yorumlar.govde.daha_az": "Daha az",
  "yorumlar.liste.daha_fazla": "Daha fazla göster ({{kalan}} kaldı)",

  // -- denetim (P5-F3) -----------------------------------------------------------
  "denetim.tur.eksik_ozellik": "Özelliği eksik",
  "denetim.tur.rozet_uyusmazlik": "Rozet uyuşmazlığı",
  "denetim.tur.celiski": "Çelişki",
  "denetim.tur.gri_alan": "Gri alan",
  "denetim.siddet.yuksek": "Yüksek",
  "denetim.siddet.orta": "Orta",
  "denetim.siddet.dusuk": "Düşük",
  "denetim.col.tur": "Tür",
  "denetim.col.urun": "Ürün",
  "denetim.col.aciklama": "Açıklama",
  "denetim.col.siddet": "Şiddet",
  "denetim.col.stok": "Stok",
  "denetim.tanimsiz": "tanımsız",
  "denetim.ozet.eksik": "Özelliği eksik",
  "denetim.ozet.rozet": "Rozet uyuşmazlığı",
  "denetim.ozet.gri": "Gri alan",
  "denetim.ozet.celiski": "Çelişki",
  "denetim.siddet_filtre.etiket": "Şiddet",
  "denetim.siddet_filtre.hepsi": "Tümü",
  "denetim.bulgu.bos": "Bu şiddette bulgu yok.",
  "denetim.son_tarama": "Son tarama: {{zaman}}",
  "denetim.hic_taranmadi": "Henüz taranmadı",
  "denetim.tara.buton": "Yeniden tara",
  "denetim.tara.calisiyor": "Taranıyor…",
  "denetim.tara.zaten_suruyor": "Tarama zaten sürüyor, mevcut işlem takip ediliyor…",
  "denetim.tara.sonuc_hata": "Tarama tamamlandı ama hata ile sonuçlandı.",
  "denetim.csv.buton": "CSV indir",

  "kit.title": "Bileşen kiti",
  "kit.subtitle": "Gorsel denetim icin tum bilesenlerin ornekleri.",

  // -- kaynak adlari (sync.intervals, kurulum ilerlemesi) ---------------------
  "source.orders": "Siparişler",
  "source.customers": "Müşteriler",
  "source.products": "Ürünler / Stok",
  "source.inventory_movements": "Stok hareketleri",
  "source.product_sales_report": "Ürün satış raporu",
  "source.returns": "İadeler",
  "source.refunds": "Para iadeleri",
  "source.tickets": "Destek talepleri",
  "source.reviews": "Yorumlar",
  "source.abandoned_carts": "Terk edilmiş sepetler",
  "source.ads_meta": "Meta reklamları",
  "source.ads_google": "Google reklamları",

  // -- /ayarlar ----------------------------------------------------------------
  "ayarlar.title": "Ayarlar",
  "ayarlar.subtitle": "Mağazanızın marka, eşik, mesai ve entegrasyon ayarlarını buradan yönetin.",
  "ayarlar.save": "Kaydet",
  "ayarlar.saving": "Kaydediliyor…",
  "ayarlar.saved": "Kaydedildi.",
  "ayarlar.save_error": "Kaydedilemedi.",
  "ayarlar.reset_field": "Varsayılana dön",
  "ayarlar.reset_done": "Varsayılana döndürüldü.",
  "ayarlar.no_changes": "Değişiklik yok.",
  "ayarlar.tabs.marka": "Marka",
  "ayarlar.tabs.esikler": "Eşikler",
  "ayarlar.tabs.mesai": "Mesai",
  "ayarlar.tabs.gorunum": "Görünüm",
  "ayarlar.tabs.ai": "AI",
  "ayarlar.tabs.hedefler": "Hedefler",
  "ayarlar.tabs.baglantilar": "Bağlantılar",
  "ayarlar.tabs.senkron": "Senkron",

  "ayarlar.marka.logo_url": "Logo URL",
  "ayarlar.marka.primary_color": "Ana renk",
  "ayarlar.marka.accent_color": "Vurgu rengi",
  "ayarlar.marka.preview": "Canlı önizleme",
  "ayarlar.marka.preview_tenant": "Mağaza Adı",

  "ayarlar.esikler.siparis_kargoya_saat": "Sipariş → kargoya (saat)",
  "ayarlar.esikler.kargo_teslim_saat": "Kargo → teslim (saat)",
  "ayarlar.esikler.stok_kritik": "Kritik stok eşiği (adet)",
  "ayarlar.esikler.destek_cevap_saat": "Destek yanıt süresi (saat)",

  "ayarlar.mesai.depo": "Depo mesaisi",
  "ayarlar.mesai.kargo": "Kargo mesaisi",
  "ayarlar.mesai.weekday_start": "Hafta içi başlangıç",
  "ayarlar.mesai.weekday_end": "Hafta içi bitiş",
  "ayarlar.mesai.saturday_works": "Cumartesi çalışıyor",
  "ayarlar.mesai.saturday_start": "Cumartesi başlangıç",
  "ayarlar.mesai.saturday_end": "Cumartesi bitiş",
  "ayarlar.mesai.sunday_works": "Pazar çalışıyor",
  "ayarlar.mesai.holidays": "Tatil günleri",
  "ayarlar.mesai.holidays_hint": "YYYY-AA-GG biçiminde, virgülle ayırın.",

  "ayarlar.gorunum.hidden_cards": "Gizli kartlar",
  "ayarlar.gorunum.hidden_tabs": "Gizli sekmeler",
  "ayarlar.gorunum.hint": "İşaretlenen kart/sekmeler tüm kullanıcılardan gizlenir.",

  "ayarlar.ai.enabled": "AI özellikleri açık",
  "ayarlar.ai.tone": "Ton",
  "ayarlar.ai.tone.yonetici": "Yönetici",
  "ayarlar.ai.tone.resmi": "Resmi",
  "ayarlar.ai.tone.samimi": "Samimi",
  "ayarlar.ai.customer_display_name": "Müşteriye görünen ad",

  "ayarlar.hedefler.monthly_revenue": "Aylık ciro hedefi (₺)",
  "ayarlar.hedefler.monthly_orders": "Aylık sipariş hedefi (adet)",
  "ayarlar.hedefler.no_target": "Hedef yok",

  "ayarlar.baglantilar.ga4_property_id": "GA4 mülk kimliği",
  "ayarlar.baglantilar.ga4_hint": "VDD servis hesabına Görüntüleyici yetkisi verin.",
  "ayarlar.baglantilar.meta_account_id": "Meta reklam hesap kimliği",
  "ayarlar.baglantilar.meta_access_token": "Meta erişim anahtarı",
  "ayarlar.baglantilar.meta_token_hint": "Kaydedilen anahtar bir daha görüntülenmez; boş bırakmak mevcut anahtarı değiştirmez.",
  "ayarlar.baglantilar.meta_token_current": "Kayıtlı bir anahtar var ({{date}})",

  "ayarlar.senkron.heavy_sources_enabled": "Ağır kaynaklar açık (TOTP/Playwright gerektiren senkronlar)",
  "ayarlar.senkron.intervals_title": "Senkron aralıkları (dakika)",

  // -- /kurulum ----------------------------------------------------------------
  "kurulum.title": "Kurulum sihirbazı",
  "kurulum.next": "İleri",
  "kurulum.back": "Geri",
  "kurulum.steps.platform": "Platform bilgisi",
  "kurulum.steps.credentials": "Kimlik bilgileri",
  "kurulum.steps.test": "Bağlantı testi",
  "kurulum.steps.sync": "İlk senkron",

  "kurulum.platform.title": "Mağaza platformu",
  "kurulum.platform.name": "Mağaza adı",
  "kurulum.platform.store_url": "Mağaza adresi",
  "kurulum.platform.hint": "Platform, mağaza oluşturulurken belirlenir ve burada değiştirilemez.",
  "kurulum.platform.ticimax": "Ticimax",
  "kurulum.platform.ikas": "ikas",
  "kurulum.platform.ideasoft": "IdeaSoft",

  "kurulum.ticimax.username": "Ticimax kullanıcı adı",
  "kurulum.ticimax.password": "Ticimax şifresi",
  "kurulum.ticimax.totp_secret": "TOTP gizli anahtarı",
  "kurulum.ticimax.ws_key": "Web servis anahtarı",
  "kurulum.ticimax.existing": "Kayıtlı: {{masked}} ({{date}})",
  "kurulum.ticimax.not_set": "Henüz girilmedi",
  "kurulum.ticimax.save": "Kimlik bilgilerini kaydet",
  "kurulum.ticimax.saved": "Kimlik bilgileri kaydedildi.",
  "kurulum.ticimax.save_error": "Kimlik bilgileri kaydedilemedi.",
  "kurulum.ticimax.empty_hint": "Yalnızca değiştirmek istediğiniz alanları doldurun.",

  "kurulum.ikas.store_name": "Mağaza adı",
  "kurulum.ikas.store_hint": "ör. magazam — myikas.com alt alan adınızın ilk kısmı",
  "kurulum.ikas.install": "Uygulamayı kur",
  "kurulum.ikas.connected": "Bağlandı: {{store}}",
  "kurulum.ikas.register_webhooks": "Webhook kaydet",
  "kurulum.ikas.webhooks_registering": "Kaydediliyor…",
  "kurulum.ikas.webhooks_registered": "Webhook'lar kaydedildi.",
  "kurulum.ikas.webhooks_error": "Webhook kaydı başarısız.",

  "kurulum.ideasoft.intro_title": "API uygulaması oluşturun",
  "kurulum.ideasoft.intro_body":
    "Mağaza sahibi olarak IdeaSoft yönetim panelinde Entegrasyonlar → API → Ekle yolunu izleyerek bir API uygulaması oluşturun. Aşağıdaki yönlendirme adresini uygulama ayarlarına girin, ardından size verilen Client ID ve Client Secret değerlerini bu sayfaya girin.",
  "kurulum.ideasoft.callback_label": "Yönlendirme adresi",
  "kurulum.ideasoft.callback_copy": "Kopyala",
  "kurulum.ideasoft.callback_copied": "Kopyalandı",
  "kurulum.ideasoft.client_id": "Client ID",
  "kurulum.ideasoft.client_secret": "Client Secret",
  "kurulum.ideasoft.existing": "Kayıtlı: {{masked}} ({{date}})",
  "kurulum.ideasoft.not_set": "Henüz girilmedi",
  "kurulum.ideasoft.save": "Kimlik bilgilerini kaydet",
  "kurulum.ideasoft.saved": "Kimlik bilgileri kaydedildi.",
  "kurulum.ideasoft.save_error": "Kimlik bilgileri kaydedilemedi.",
  "kurulum.ideasoft.empty_hint": "Yalnızca değiştirmek istediğiniz alanları doldurun.",
  "kurulum.ideasoft.authorize": "IdeaSoft'ta yetkilendir",
  "kurulum.ideasoft.connected": "Bağlandı: {{store}}",
  "kurulum.ideasoft.not_connected": "Henüz bağlı değil.",
  "kurulum.ideasoft.token_expires_at": "Jeton geçerlilik süresi: {{date}}",
  "kurulum.ideasoft.status_error": "Bağlantı durumu okunamadı.",
  "kurulum.ideasoft.err.genel": "IdeaSoft yetkilendirmesi tamamlanamadı ({{code}}). Yeniden deneyin.",
  "kurulum.ideasoft.err.kimlik_bilgisi_eksik": "Önce Client ID ve Client Secret bilgilerini kaydedin, sonra yetkilendirin.",
  "kurulum.ideasoft.err.store_url_eksik": "Mağaza adresi tanımlı değil. Yöneticinize başvurun.",
  "kurulum.ideasoft.err.state": "Yetkilendirme oturumu doğrulanamadı. \"IdeaSoft'ta yetkilendir\" ile yeniden başlatın.",
  "kurulum.ideasoft.err.token": "IdeaSoft erişim jetonu vermedi. Client Secret ve yönlendirme adresini kontrol edin.",
  "kurulum.ideasoft.err.reddedildi": "Yetkilendirme IdeaSoft tarafında reddedildi.",
  "kurulum.ideasoft.err.platform": "Bu mağaza IdeaSoft platformunda değil.",

  "kurulum.test.title": "Bağlantı testi",
  "kurulum.test.run": "Bağlantı testini başlat",
  "kurulum.test.running": "Test çalışıyor…",
  "kurulum.test.queued": "Zaten kuyrukta, sonuç bekleniyor…",
  "kurulum.test.ok": "Bağlantı başarılı.",
  "kurulum.test.failed": "Bağlantı başarısız.",
  "kurulum.test.checks": "Kontroller",
  "kurulum.test.no_result": "Henüz test çalıştırılmadı.",

  "kurulum.sync.start": "İlk senkronu başlat",
  "kurulum.sync.starting": "Başlatılıyor…",
  "kurulum.sync.enqueued": "{{n}} kaynak kuyruğa alındı.",
  "kurulum.sync.cooldown": "Soğuma süresinde, biraz sonra tekrar deneyin.",
  "kurulum.sync.progress": "Kaynak ilerlemesi",
  "kurulum.sync.go_to_ozet": "Gidişat özetine git",
  "kurulum.sync.no_sources": "Bu platform için desteklenen kaynak bulunamadı.",

  // -- /kullanicilar -------------------------------------------------------------
  "kullanicilar.title": "Kullanıcılar",
  "kullanicilar.list.title": "Üyeler",
  "kullanicilar.pending.title": "Bekleyen onaylar",
  "kullanicilar.table.email": "E-posta",
  "kullanicilar.table.name": "Ad Soyad",
  "kullanicilar.table.role": "Rol",
  "kullanicilar.table.status": "Durum",
  "kullanicilar.table.actions": "İşlemler",
  "kullanicilar.approve": "Onayla",
  "kullanicilar.reject": "Reddet",
  "kullanicilar.reject.reason_label": "Red nedeni",
  "kullanicilar.reject.reason_placeholder": "Neden? (opsiyonel)",
  "kullanicilar.reject.confirm": "Reddet",
  "kullanicilar.reject.cancel": "Vazgeç",
  "kullanicilar.remove": "Üyeliği sil",
  "kullanicilar.remove.confirm": "{{email}} üyeliğini silmek istediğinize emin misiniz?",
  "kullanicilar.role.tenant_admin": "Yönetici",
  "kullanicilar.role.tenant_user": "Kullanıcı",
  "kullanicilar.empty": "Henüz üye yok.",
  "kullanicilar.pending.empty": "Bekleyen onay yok.",
  "kullanicilar.add.title": "Kullanıcı ekle",
  "kullanicilar.add.email": "E-posta",
  "kullanicilar.add.first_name": "Ad",
  "kullanicilar.add.last_name": "Soyad",
  "kullanicilar.add.role": "Rol",
  "kullanicilar.add.submit": "Ekle",
  "kullanicilar.add.success_existing": "Mevcut kullanıcı mağazaya eklendi.",
  "kullanicilar.add.password_title": "Tek seferlik şifre",
  "kullanicilar.add.password_warning": "Bu şifre bir daha gösterilmeyecek — şimdi kopyalayıp kullanıcıya iletin.",
  "kullanicilar.add.copy": "Kopyala",
  "kullanicilar.add.copied": "Kopyalandı.",
  "kullanicilar.add.close": "Kapat",

  // -- /admin --------------------------------------------------------------------
  "admin.title": "Süper yönetici",
  "admin.tenants.title": "Mağazalar",
  "admin.tenants.create": "Mağaza oluştur",
  "admin.tenants.switch": "Bu mağazaya geç",
  "admin.tenants.slug": "Kod (slug)",
  "admin.tenants.name": "Ad",
  "admin.tenants.platform": "Platform",
  "admin.tenants.status": "Durum",
  "admin.tenants.last_sync": "Son senkron",
  "admin.tenants.last_error": "Son hata",
  "admin.tenants.job_failures": "24s iş hatası",
  "admin.tenants.ai_cost": "Bu ay AI maliyeti",
  "admin.create.submit": "Oluştur",
  "admin.create.success": "Mağaza oluşturuldu.",
  "admin.create.error": "Mağaza oluşturulamadı.",
  "admin.worker.title": "Worker sağlığı",
  "admin.worker.alive": "Çalışıyor",
  "admin.worker.dead": "Yanıt vermiyor",
  "admin.worker.last_seen": "Son görülme: {{time}}",
  "admin.worker.never": "Hiç görülmedi",
  "admin.usage.title": "Aylık AI kullanımı",
  "admin.usage.month": "Ay",
  "admin.usage.calls": "Çağrı",
  "admin.usage.tokens": "Token (giriş/çıkış)",
  "admin.usage.cost": "Maliyet (₺)",
  "admin.usage.total": "Toplam",

  // -- /ozet + /kpi (P5-F2) ---------------------------------------------------
  "ozet.hata": "Gidişat verisi alınamadı.",
  "ozet.operasyon_kartlari": "Operasyon kartları",

  // -- Görev: eski ana sayfa bölüm sırası (BugunSeridi/CiroTrendi/opKpis/vb.) --
  "ozet.bant.baslik": "Bugün",
  "ozet.bant.siparis": "Sipariş",
  "ozet.bant.ciro": "Ciro",
  "ozet.bant.yeni_uye": "Yeni üye",
  "ozet.bant.acilan_destek": "Açılan destek",
  "ozet.bant.odeme_bekleyen": "Ödeme bekleyen",

  "ozet.trend.baslik": "Günlük ciro trendi",
  "ozet.trend.veri_yok": "Günlük seri yok.",
  "ozet.trend.gun_etiketi": "Gün {{n}}",
  "ozet.trend.son_n_gun": "Son {{n}} gün",
  "ozet.trend.onceki_n_gun": "Önceki {{n}} gün",
  "ozet.trend.tablo_ac": "Günlük değerler (tablo)",
  "ozet.trend.tablo_baslik": "Günlük ciro ve sipariş — {{cur}} ile {{prev}}",
  "ozet.trend.kolon.gun": "Gün",
  "ozet.trend.kolon.tarih": "Tarih",
  "ozet.trend.kolon.ciro": "Ciro",
  "ozet.trend.kolon.siparis": "Sipariş",
  "ozet.trend.kolon.onceki_tarih": "Önceki tarih",
  "ozet.trend.kolon.onceki_ciro": "Önceki ciro",
  "ozet.trend.kolon.onceki_siparis": "Önceki sipariş",

  "ozet.op_kpis.baslik": "AsakAI Operasyonel Durum",
  "ozet.op_kpis.alt": "Acil dikkat gerekenler",

  "ozet.destek_iade.baslik": "Cevap bekleyen destek + iade talepleri",
  "ozet.destek_iade.tab_destek": "Destek talepleri",
  "ozet.destek_iade.tab_iade": "İade talepleri",

  "ozet.kargo_sirketi.baslik": "Kargo Şirketi Dağılımı",
  "ozet.kargo_sirketi.not": "bekleyen siparişler şirket bazlı",
  "ozet.kargo_sirketi.bos": "Bekleyen kargo verisi yok.",
  "ozet.kargo_sirketi.yolda": "Yolda",
  "ozet.kargo_sirketi.kritik": "kritik",
  "ozet.kargo_sirketi.uyari": "uyarı",
  "ozet.kargo_sirketi.hepsi_suresinde": "✓ Hepsi süresinde",

  "ozet.yorum_ozet.baslik": "⭐ Yorumlar & ortalama puan",
  "ozet.yorum_ozet.sekme_link": "Yorumlar sekmesi →",
  "ozet.yorum_ozet.hic_yok": "Henüz yorum yok",
  "ozet.yorum_ozet.dusuk_uyari": "⚠ {{n}} düşük puanlı (≤2⭐) yorum ilgi bekliyor",
  "ozet.yorum_ozet.hepsi_olumlu": "hepsi olumlu",
  "ozet.yorum_ozet.onay_bekleyen": "{{n}} yorum Ticimax'te onay bekliyor",

  "ozet.encok_satan.baslik": "Bu Haftanın En Çok Satan Ürünleri",
  "ozet.encok_satan.urun": "Ürün",
  "ozet.encok_satan.adet": "Adet",
  "ozet.encok_satan.ciro": "Ciro",

  "health.verdict.bilinmiyor_baslik": "Sağlık skoru hesaplanamadı",
  "health.verdict.bilinmiyor_aciklama": "Ölçülen operasyon KPI'sı yok.",
  "health.verdict.acil_baslik": "Acil müdahale gerekli",
  "health.verdict.acil_aciklama": "Birden fazla KPI kritik eşiği aştı.",
  "health.verdict.risk_baslik": "Operasyonel risk var",
  "health.verdict.risk_aciklama": "Birkaç KPI kritik bölgede; öncelik ver.",
  "health.verdict.dikkat_baslik": "Dikkat — küçük problemler var",
  "health.verdict.dikkat_aciklama": "Bazı KPI'lar dikkat eşiğinde, takip et.",
  "health.verdict.temiz_baslik": "Genel durum iyi",
  "health.verdict.temiz_aciklama": "Açık uyarıları aşağıdaki kartlardan takip edin.",

  "ozet.veri_yok": "veri yok",
  "ozet.onceki_donem_yok": "önceki dönem verisi yok",
  "ozet.anlik_veri": "anlık · son veri çekimi",
  "ozet.detay_link": "Detay →",

  "ozet.blok.satis": "Satış",
  "ozet.blok.pazarlama": "Pazarlama",
  "ozet.blok.musteri": "Müşteri",
  "ozet.blok.operasyon": "Operasyon",

  "ozet.metrik.ciro": "Ciro",
  "ozet.metrik.siparis": "Sipariş",
  "ozet.metrik.sepet_ortalama": "Sepet ortalaması",
  "ozet.metrik.yeni_musteri": "Yeni müşteri",
  "ozet.metrik.reklam_harcama": "Reklam harcaması",
  "ozet.metrik.roas": "ROAS",
  "ozet.metrik.mer": "MER (ciro ÷ harcama)",
  "ozet.metrik.reklam_maliyet_orani": "Reklam maliyet oranı",
  "ozet.metrik.yorum": "Yorum",
  "ozet.metrik.ortalama_puan": "Ortalama puan",
  "ozet.metrik.dusuk_puan": "Düşük puan",
  "ozet.metrik.destek_bekleyen": "Destek bekleyen",
  "ozet.metrik.teslim_suresi": "Teslim süresi (ort.)",
  "ozet.metrik.kargolanmamis": "Kargolanmamış",
  "ozet.metrik.yolda_14g": "Yolda 14 gün+",
  "ozet.metrik.kritik_stok": "Kritik stok",

  "ozet.hedef.title": "Hedef gerçekleşme",

  "ozet.ai.baslik": "AI Gidişat Notu",
  "ozet.ai.hata": "AI notu alınamadı: {{detay}}",
  "ozet.ai.hazirlaniyor": "AI notu hazırlanıyor… ~15-30 sn",
  "ozet.ai.bos": "Bu dönem için henüz AI notu yok.",
  "ozet.ai.uretim_hata": "AI notu üretilemedi: {{detay}}",
  "ozet.ai.yeniden_uret": "Yeniden üret",
  "ozet.ai.uretim": "üretim",
  "ozet.ai.bayat": "güncel değil",
  "ozet.ai.analiz_yukleniyor": "Analiz ediliyor… ~10-30 sn",
  "ozet.ai.kapali": "AI özellikleri bu mağaza için kapalı.",

  "ozet.detay.kargo_sirketi": "Kargo şirketi",
  "ozet.detay.adet": "Adet",
  "ozet.detay.toplam_stok": "toplam stok",
  "ozet.detay.kolon_yok": "Bu kart için ayrıntılı kolon tanımı yok.",

  "ozet.teslimat_haftalik": "Haftalık teslimat süresi",
  "ozet.teslimat_gun": "Ortalama teslimat (gün)",
  "ozet.saatlik_satis": "Saatlik satış",
  "ozet.bugun": "Bugün",
  "ozet.dun": "Dün",

  "health.breakdown.toggle": "Sağlık skoru dökümünü göster",
  "health.breakdown.title": "Sağlık skoru dökümü",

  "kpi.detayli_kartlar": "Detaylı KPI kartları",
  "kpi.huni": "E-ticaret satış hunisi",
  "kpi.meta_ads": "Meta reklamları",
  "kpi.google_ads": "Google reklamları",
  "kpi.reklam_satis_degeri": "Reklam satış değeri",
  "kpi.tiklama": "Tıklama",
  "kpi.ga4_arama": "GA4 trafik",
  "kpi.oturum": "Oturum",
  "kpi.kullanici": "Kullanıcı",
  "kpi.donusum_orani": "Dönüşüm oranı",
  "kpi.snapshot_hata": "KPI anlık görüntüsü alınamadı, önceki değerler gösteriliyor olabilir.",
  "kpi.seviye.kritik": "Kritik",
  "kpi.seviye.uyari": "Uyarı",
  "kpi.seviye.ok": "Yeterli",
  "kpi.sure.mesai_disi": "mesai dışı",

  "funnel.aria_label": "E-ticaret satış hunisi",
  "funnel.previous_period": "önceki dönem",
  "funnel.note_closed": "Kapalı huni (GA4): her aşama, önceki aşamaları sırayla tamamlayan kullanıcılar.",
  "funnel.note_open": "Aşamayı içeren oturum sayıları (GA4). Huni şekli şematiktir; oranlar sağda gösterilir.",
  "funnel.empty_body": "GA4 huni verisi şu an bu mağaza için bağlı değil.",
} as const;

export type TrKey = keyof typeof tr;
